exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\r\n\twidth: 100%;\r\n\tbackground-color: #fccf31;\r\n\tbackground-image: linear-gradient(141deg, #fccf31 0%, #f55555 100%);\r\n}\r\n\r\nfooter .content {\r\n\tmax-width: 1024px;\r\n\tmargin: auto;\r\n\tpadding: 1em 2em;\r\n\r\n\tcolor: var(--background);\r\n\tfont-size: 0.75em;\r\n}\r\n\r\nfooter .content p {\r\n\tpadding-bottom: 1em;\r\n}\r\n\r\nfooter h4 {\r\n\ttext-transform: uppercase;\r\n\tfont-weight: bold;\r\n\tpadding-top: 1em;\r\n}\r\n\r\nfooter a {\r\n\tcolor: black;\r\n\tfont-size: bold;\r\n}", ""]);

// exports
